export default __webpack_public_path__ + "static/media/650896ef1a61a1de91e11faa569e9e3b.svg";